/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemLinkType } from './MailboxItemLinkType';
import {
    MailboxItemLinkTypeFromJSON,
    MailboxItemLinkTypeFromJSONTyped,
    MailboxItemLinkTypeToJSON,
    MailboxItemLinkTypeToJSONTyped,
} from './MailboxItemLinkType';

/**
 * 
 * @export
 * @interface MailboxItemLinkDTO
 */
export interface MailboxItemLinkDTO {
    /**
     * 
     * @type {MailboxItemLinkType}
     * @memberof MailboxItemLinkDTO
     */
    Type?: MailboxItemLinkType;
    /**
     * 
     * @type {number}
     * @memberof MailboxItemLinkDTO
     */
    LinkedId?: number;
}



/**
 * Check if a given object implements the MailboxItemLinkDTO interface.
 */
export function instanceOfMailboxItemLinkDTO(value: object): value is MailboxItemLinkDTO {
    return true;
}

export function MailboxItemLinkDTOFromJSON(json: any): MailboxItemLinkDTO {
    return MailboxItemLinkDTOFromJSONTyped(json, false);
}

export function MailboxItemLinkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemLinkDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Type': json['Type'] == null ? undefined : MailboxItemLinkTypeFromJSON(json['Type']),
        'LinkedId': json['LinkedId'] == null ? undefined : json['LinkedId'],
    };
}

export function MailboxItemLinkDTOToJSON(json: any): MailboxItemLinkDTO {
    return MailboxItemLinkDTOToJSONTyped(json, false);
}

export function MailboxItemLinkDTOToJSONTyped(value?: MailboxItemLinkDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Type': MailboxItemLinkTypeToJSON(value['Type']),
        'LinkedId': value['LinkedId'],
    };
}

